// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e1b95049","121":"7fed8bb6","198":"024328fe","391":"a3e6ee90","404":"b5801dac","498":"0f58f55b","760":"c34adf25","824":"e2149c2f","923":"449a682a"}[chunkId] + ".chunk.js";
};